import React from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_flats-clean-service/artifacts/2b1a8yim_Screenshot_20260123_012606_Drive.jpg";

const Footer = ({ data }) => {
  return (
    <footer className="px-5 sm:px-6 py-10 sm:py-12 bg-[#1a1f4e] text-white">
      <div className="max-w-3xl mx-auto text-center">
        {/* Final Trust Line */}
        <p className="text-gray-300 text-sm mb-8">
          Fully insured • Fixed rota • One point of contact
        </p>
        
        <div className="flex items-center justify-center mb-6">
          <div className="bg-white rounded-xl px-4 py-2.5">
            <img 
              src={LOGO_URL} 
              alt="Just Cleaned" 
              className="h-7 sm:h-8 w-auto object-contain"
            />
          </div>
        </div>
        
        <p className="text-gray-300 text-sm mb-1.5">{data.tagline}</p>
        <p className="text-gray-300 text-sm mb-1.5">{data.location}</p>
        <p className="text-gray-400 text-xs mb-2">{data.insurance}</p>
        <p className="text-gray-500 text-xs mb-8">Established 2012.</p>
        
        {/* Legal Links */}
        <div className="border-t border-gray-600/50 pt-6">
          <p className="text-gray-500 text-xs">
            <a 
              href="/privacy-policy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-gray-300 transition-colors"
            >
              Privacy Policy
            </a>
            <span className="mx-2 text-gray-600">|</span>
            <a 
              href="/cookie-policy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-gray-300 transition-colors"
            >
              Cookie Policy
            </a>
            <span className="mx-2 text-gray-600">|</span>
            <a 
              href="/terms-conditions" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-gray-300 transition-colors"
            >
              Terms & Conditions
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
